//
//
//
//
//
//
//
//

export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    translate: {
      type: Boolean,
      default: true
    }
  }
}
